module.exports = __webpack_public_path__ + "img/39.5b6b677f.jpg";